/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Admin_Funnel_History_SyncedInputs */

const en_admin_funnel_history_synced = /** @type {(inputs: Admin_Funnel_History_SyncedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Traffic imported through ${i?.day}. Run \`npx tsx scripts/sync-traffic.ts\` to refresh.`)
};

/**
* | output |
* | --- |
* | "Traffic imported through {day}. Run `npx tsx scripts/sync-traffic.ts` to refresh." |
*
* @param {Admin_Funnel_History_SyncedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_history_synced = /** @type {((inputs: Admin_Funnel_History_SyncedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_History_SyncedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_history_synced(inputs)
});
export { admin_funnel_history_synced as "admin.funnel.history.synced" }